import { Lock } from '@mui/icons-material';
import { Box, Grid, Tab, Tabs, Typography } from "@mui/material/";
import { useContext, useState } from 'react';
import { IPermissionContext, PermissionContext } from '../../contexts/PermissionContext';
import { Role } from '../../utils';
import { BreadcrumbBar } from '../Breadcrumb';
import { TabPanel } from '../Shared/TabPanel';
import { UserManager } from './UserManager';
import { ValueManager } from './ValueManager';



const PermissionDenied = (role: string) => {
    return (
        <Box textAlign="center" sx={{ opacity: .5 }}>
            <Lock />
            <Typography>
                You do not have permission to view these settings.
            </Typography>
            <small>({role} not permitted)</small>
        </Box>
    )
}

const devAccount = (permissionContext: IPermissionContext) => {
    let uName = permissionContext.userName.toUpperCase();
    return [
        "eric.riley@syntaxits.com".toUpperCase(),
        "justin.hillyard@syntaxits.com".toUpperCase(),
    ].includes(uName);
}

export const Settings: React.FC = () => {

    const [value, setValue] = useState(0);

    const permissionContext = useContext(PermissionContext);

    return (

        <div>
            <BreadcrumbBar
                current={"Settings"}
                previous={[]}
            />
            <Grid container spacing={2} sx={{ my: 3 }}>
                <Grid item xs={12}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={value} onChange={(_, value) => setValue(value)} aria-label="settings-tabs">
                            <Tab
                                label="Users"
                                id={`settings-tab-${0}`} />
                            <Tab
                                label="LOV Management"
                                id={`settings-tab-${1}`}
                            />
                        </Tabs>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <TabPanel value={value} index={0}>
                        <>
                            {
                                (permissionContext.isRole(Role.Internal.Admin)
                                    || devAccount(permissionContext)) ?
                                    <UserManager /> :
                                    PermissionDenied(permissionContext.roleName)
                            }
                        </>

                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        {
                            (permissionContext.isRole(Role.Internal.AssetProtection)
                                || devAccount(permissionContext)) ?
                                <ValueManager />
                                : PermissionDenied(permissionContext.roleName)
                        }
                    </TabPanel>
                </Grid>
            </Grid>
        </div>);
}